export default __webpack_public_path__ + "static/media/Brain-03.087d157e.svg";